<template>
  <div class="pagination-box">
    <p class="pagination-box__text mb-0 wd-text-otempsm">
      {{ $t('result_change_page', { start: startIndex, end: endIndex, total: totalCount }) }}
    </p>
    <client-only>
      <v-pagination
        v-model="pageIndex"
        class="pagination-box__bar"
        :length="pageCount"
        :total-visible="visible"
        active-color="orange50"
        variant="flat"
        @update:model-value="updatePage"
      />
    </client-only>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    count: { type: Number, default: 0 },
    visible: { type: Number, default: 5 },
    size: { type: Number, default: 20 },
    totalCount: { type: Number, default: 0 },
    page: { type: Number, default: 1 },
  },
  emits: ['update'],
  data() {
    return {
      pageIndex: this.page,
    }
  },
  computed: {
    pageCount() {
      return this.count ? this.count : Math.ceil(this.totalCount / this.size)
    },
    startIndex() {
      return this.getStartIndex(this.pageIndex)
    },
    endIndex() {
      return this.getEndIndex(this.pageIndex)
    },
  },
  watch: {
    page(newPage) {
      this.pageIndex = newPage
    },
  },
  methods: {
    getStartIndex(page) {
      return (page - 1) * this.size + 1
    },
    getEndIndex(page) {
      const endIndex = page * this.size
      return endIndex > this.totalCount ? this.totalCount : endIndex
    },
    updatePage(page) {
      this.$emit('update', page)
    },
  },
}
</script>
<style lang="scss" scoped>
.pagination-box {
  margin: auto;
  display: flex;
  flex-flow: column;

  &__text {
    text-align: center;
    color: $gray80;
  }
  &__bar {
    margin-top: 20px;
  }
}
</style>
